import React from 'react'
import * as common from "../const/Common/CommonFunc";

export const invalidPasswordText = `Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS`;

export const textFieldValidator = (value, length) => {
  if (value.trim() === "") {
    return false;
  } else return value.length >= length;
};

export const identityValueValidator = (identity, type ,isWarning) => {

  let passportRegex = new RegExp("^([a-zA-Z]{2}[0-9]{7}|[a-zA-Z]{2}[0-9]{8})$");
  let drivingLicenceRegex = new RegExp("^([a-zA-Z][0-9]{7}|[a-zA-Z][0-9]{8})$");
  let nicRegex = new RegExp("^([0-9]{9}[V|v|X|x]|[0-9]{12})$");

  if (type === undefined || type === "ALL") {
    if (passportRegex.test(identity) || drivingLicenceRegex.test(identity) || nicRegex.test(identity)) {
      return true;
    } else {
      if(isWarning === undefined){
        common.notifyMessage("Please enter valid 'NIC/Passport/Driving Licence' number");
      }
      return false;
    }
  } else if (type === "NIC" || type === "nic") {
    if (nicRegex.test(identity)) {
      return true;
    } else {
      if(isWarning === undefined) {
        common.notifyMessage("Please enter valid '" + type + "' number");
      }
      return false;
    }
  } else if (type === "Driving Licence" || type.toLowerCase().indexOf('driving') !== -1 || type.toLowerCase().indexOf('licence') !== -1) {
    if (identity.length > 5) {
      return true;
    } else {
      if(isWarning === undefined) {
        common.notifyMessage("Please enter valid '" + type + "' number");
      }
      return false;
    }
  } else if (type === "Passport" || type.toLowerCase().indexOf('passport') !== -1) {
    if (identity.length > 5) {
      return true;
    } else {
      if(isWarning === undefined) {
        common.notifyMessage("Please enter valid '" + type + "' number");
      }
      return false;
    }
  }
};

export const basicMobileNumberValidator = (identity, type) => {
  return identity.length >= 9;
};

export const mobileNumValidator = (identity, type , condition) => {
  let mobileNumRegex = new RegExp(
    "^(077)[0-9]{7}$|^(076)[0-9]{7}$|^(075)[0-9]{7}$|^(071)[0-9]{7}$|^(072)[0-9]{7}$|^(070)[0-9]{7}$|^(078)[0-9]{7}$|^(074)[0-9]{7}$|^(77)[0-9]{7}$|^(76)[0-9]{7}$|^(75)[0-9]{7}$|^(71)[0-9]{7}$|^(72)[0-9]{7}$|^(70)[0-9]{7}$|^(78)[0-9]{7}$|^(74)[0-9]{7}$");
  if (mobileNumRegex.test(identity)) {
    return true;
  } else {
    if(condition !== 1){
      common.notifyMessage("Please enter valid 'Mobile' number. (Ex: 07XXXXXXXX)");
    }
    return false;
  }
};

export const linkedInUrlValidator = url => {
  let reg = new RegExp('^(https?://)?((www|\\w\\w)\\.)?linkedin.com/((in/[^/]+/?)|(pub/[^/]+/((\\w|\\d)+/?){3}))$');
  return reg.test(url.trim());
};

export const isOnlyNumbersValdator = value => {
  let reg = new RegExp('^\\d+$');
  return reg.test(value.trim());
};

export const webAddressValidator = (value) => {
  let web_regx = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
  return web_regx.test(value)
};

export const passwordValidator = (value) => {
  let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
  return reg.test(value)
};

export const contactNoValidator = (value) => {
  let reg = new RegExp("^(0)[0-9]{9}$|^[1-9][0-9]{8}$");
  return reg.test(value)
};

export const customMobileValidation = (number,condition) => {
  let result = condition;
  if(!result){
    let reg = new RegExp("^(9474)[0-9]{7}$");
    result = reg.test(number)
  }
  return result;
};

export const keyPressDigitAndDotValidation = (value) => {
  let reg = /^(?:0|[1-9][0-9]*)\.[0-9]+$|^\d+$|^([0-9]\.*)+$/;
  return reg.test(value) || value === "";
};

export const portValidation = (value) => {
  return (value >= 1 && value <= 65535) || value ===  "" ;
};

export const ipAddressValidation = (value) => {
  let reg = new RegExp("^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$");
  return reg.test(value)
};

export const vehicleNumberPlateValidation = (value) => {
  // let reg = new RegExp("^[A-Z]{2}\\s[0-9]{2}\\s[A-Z]{2}\\s[0-9]{4}$");
  let reg = new RegExp("^([a-zA-Z]{2,3}|[0-9]{2,3})\-[0-9]{4}$");
  return reg.test(value);
};
export const keyPressVehicleNumberValidation = (value) => {
  let reg = new RegExp("^[0-9A-Za-z-]+$");
  return reg.test(value) || value === "";
};

export const validateIsUrl = (value) => {
  let reg = new RegExp("((([A-Za-z]{3,9}:(?:\\/\\/)?)(?:[-;:&=\\+\\$,\\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\\+\\$,\\w]+@)[A-Za-z0-9.-]+)((?:\\/[\\+~%\\/.\\w-_]*)?\\??(?:[-\\+=&;%@.\\w_]*)#?(?:[\\w]*))?)");
  return reg.test(value);
}
